import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './MergedTable.module.css';
import tableMergeEnum from '../../../../enums/tableMergeEnum';
import split from '../../../../assets/images/Fireboard/split.png';

const MergedTable = props => {
  const {
    active,
    flexBasis,
    station,
    employee,
    minus,
    onClick,
    isEmployee,
    name,
    isEmployeeView,
    isStationView,
    revenueCentersMap,
  } = props;

  let firstName = '';
  let lastName = '';
  let posId = '';
  let revenueCenterName = '';

  if (isEmployee) {
    const emp = isEmployeeView ? employee?.employee : employee;
    firstName = emp?.firstName;
    lastName = emp?.lastName;
    posId = emp?.posId;
  } else {
    const stationObj = isStationView ? station?.station : station;
    const { revenueCenterId } = stationObj || {};
    revenueCenterName = revenueCentersMap.has(revenueCenterId) ? revenueCentersMap.get(revenueCenterId) : '';
  }

  const handleAssign = () => {
    onClick && onClick(station, employee, tableMergeEnum.ASSIGN);
  };

  const handleRemove = () => {
    onClick && onClick(station, employee, tableMergeEnum.REMOVE)
  };

  const empStyles = { width: minus ? '70%' : '100%' };
  const tableStyles = { width: minus ? '60%' : '100%' };

  return (
    <div className={styles.container} style={{ border: active ? '0.4vh solid #ad0028' : null, width: flexBasis }}>
      {isEmployee ? (
        <div className={styles.innerContainer} style={empStyles} onClick={handleAssign}>
          <span className={classNames({ [styles.centerAlignTxt]: true, [styles.employeeName]: true })}>{posId || ''}</span>
          <span className={classNames({ [styles.centerAlignTxt]: true, [styles.employeeName]: true })}>{lastName || ''},</span>
          <span className={classNames({ [styles.centerAlignTxt]: true, [styles.employeeName]: true })}>{firstName || ''} </span>
        </div>
      ) :
        <div className={styles.innerContainer} style={tableStyles} onClick={handleAssign}>
          <span className={classNames({ [styles.centerAlignTxt]: true, [styles.stationNum]: true })}>{name || ''}</span>
          {revenueCenterName && (
            <span className={classNames({ [styles.centerAlignTxt]: true, [styles.revCenterName]: true })}>({revenueCenterName})</span>
          )}
        </div>
      }
      {minus && (
        <span
          className={classNames({ [styles.centerAlignTxt]: true, [styles.minus]: true })}
          onClick={handleRemove}>
          <img src={split} alt='' className={styles.imgs} />
        </span>
      )}
    </div >
  );
};

export default MergedTable;

MergedTable.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  flexBasis: PropTypes.any,
  minus: PropTypes.bool,
  station: PropTypes.any,
  revenueCentersMap: PropTypes.instanceOf(Map),
};

MergedTable.defaultProps = {
  active: false,
  onClick: () => { },
  minus: false,
  revenueCentersMap: new Map(),
};
